
const PersonListIcon = () => {
    return (
        <svg width="43" height="45" viewBox="0 0 43 45" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.9307 0.75122C24.7213 0.75122 29.4316 5.44495 29.4316 11.215C29.4316 16.9851 24.7213 21.6788 18.9307 21.6788C13.1402 21.6788 8.42982 16.9851 8.42982 11.215C8.42982 5.44495 13.1402 0.751219 18.9307 0.75122Z" fill="#9F7EDC" />
            <path d="M5.28728 27.8996C8.29218 24.7735 12.2716 23.0478 16.4947 23.0478L21.3676 23.0479C25.5907 23.0479 29.5701 24.7735 32.575 27.8996C35.052 30.4838 36.6032 33.76 37.058 37.2863C37.3016 39.1786 35.9779 40.7208 34.1181 40.7208L3.72798 40.7208C1.8682 40.7208 0.544413 39.1786 0.788054 37.2863C1.25097 33.76 2.80215 30.4838 5.28728 27.8996Z" fill="#9F7EDC" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M28.0109 20.9166C25.9123 20.9166 24.2109 22.6179 24.2109 24.7166V40.7012C24.2109 42.7999 25.9123 44.5012 28.0109 44.5012H36.6037L42.8394 38.2654V24.7166C42.8394 22.6179 41.1381 20.9166 39.0394 20.9166H28.0109Z" fill="#CCB0FF" />
            <rect x="27.3174" y="26.0023" width="12.8294" height="1.52432" rx="0.762159" fill="#9F7EDC" />
            <rect x="27.3174" y="30.36" width="12.8294" height="1.52432" rx="0.762159" fill="#9F7EDC" />
            <rect x="27.3174" y="34.7178" width="8.42372" height="1.52431" rx="0.762157" fill="#9F7EDC" />
        </svg>

    )
}

export default PersonListIcon;

